<template>
    <div>
        <!--查看大图弹框-->
        <el-dialog
            :title="$t('Image')"
            :visible.sync="isShowBigImgFrom"
            :close-on-click-modal="false" 
            :close-on-press-escape="false"
            width="40%"
            :show-close="showClose">
            <div>
                <img :src="bigImgUrl" width="96%" height="96%" style="margin: 1% 2%;" alt="">
            </div>
        </el-dialog>
        <div v-show="model === 1" class="userMessagesBox">
            <div class="serachBox">
                <div class="serachLeft">
                    <el-input v-model="serach.title" class="serachInput" :placeholder="$t('EnterTitle')"></el-input>
                    <el-select v-model="serach.country" class="serachSel" :placeholder="$t('Country')" clearable>
                        <el-option
                        v-for="item in serach.countryOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                    <el-select v-model="serach.problemType" class="serachSel" :placeholder="$t('ProblemType')" clearable>
                        <el-option
                        v-for="item in serach.problemTypeOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                    <el-select v-model="serach.status" class="serachSel" :placeholder="$t('ReleaseStatus')" clearable>
                        <el-option
                        v-for="item in serach.statusOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                    <div class="dataBox">
                        <div>
                            <el-date-picker
                            :placeholder="$t('StartTime')"
                            v-model="serach.startTime"
                            type="datetime"
                            value-format="timestamp"
                            >
                            </el-date-picker>
                        </div>
                    </div>
                    <div class="dateDivider">_</div>
                    <div class="dataBox">
                        <div>
                            <el-date-picker
                            :placeholder="$t('EndTime')"
                            v-model="serach.endTime"
                            type="datetime"
                            value-format="timestamp"
                            >
                            </el-date-picker>
                        </div>
                    </div>
                    <el-button type="primary" class="serachBtn" :loading="serach.serachBtnState === 1" @click="serachUserMessages">{{$t('Serach')}}</el-button>
                </div>
            
            </div>
            <el-divider></el-divider>
            <div>
                <div class="noMessage" v-show="isNoMessages">{{$t('NoData')}}</div>
                <template>
                    <el-table
                    v-show="!isNoMessages"
                    :data="messagesListData"
                    style="width: 100%;"
                    :header-cell-style="{background:'#EDEFFB',color:'#4D4D4F'}"
                    >
                        <el-table-column
                            prop="username"
                            :label="$t('Users')"
                            >
                            <template slot-scope="scope">
                                {{ $handFieldNull(scope.row.username)}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="country"
                            :label="$t('Country')"
                            >
                            <template slot-scope="scope">
                                {{ handCountryCodeName(scope.row.country)}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="contact"
                            :label="$t('EmailOrPhone')"
                            >
                        </el-table-column>
                        <el-table-column
                            prop="title"
                            :label="$t('TitleTable')"
                            >
                        </el-table-column>
                        <el-table-column
                            prop="problemType"
                            :label="$t('ProblemType')"
                            >
                            <template slot-scope="scope">
                                {{ getProblemTypeStr(scope.row.problemType)}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="status"
                            :label="$t('Status')"
                            >
                            <template slot-scope="scope">
                                <el-badge v-if="scope.row.newReply === 1" is-dot class="badgeItem">
                                    {{ getMessagesStatusStr(scope.row.status)}}
                                </el-badge>
                                <span v-else> {{ getMessagesStatusStr(scope.row.status)}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="createTime"
                            :label="$t('CreateDate')"
                            >
                            <template slot-scope="scope">
                                {{ utctolocal(scope.row.createTime)}}
                            </template>
                        </el-table-column>
                        <el-table-column width="300"  label="..." align="center">
                            <template slot-scope="scope">
                                <span @click="moreInfo(scope.row)" style="color: #6498B5; cursor: pointer;">{{$t('More')}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
                <div class="pageBox" v-show="!isNoMessages">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page.sync="currentPage"
                        :page-size="10"
                        layout="prev, pager, next, jumper"
                        :total="totalLogs"
                    >
                    </el-pagination>
                </div>
                
            </div>
        </div>
        <div v-show="model === 2" class="messageDetail">
            <div class="messageDetailTex"><el-divider direction="vertical"></el-divider> <span>{{$t('ReplyMessage')}}</span></div>
            <div class="replyTopBox">
                <div style="display: flex;flex-wrap: wrap;">
                    <div class="replyTopItem">
                        <span>{{ $t('Title') }}</span>
                        <span>{{detail.title}}</span>
                    </div>
                    <div class="replyTopItem">
                        <span>{{ $t('Name') + "：" }}</span>
                        <span>{{detail.userName}}</span>
                    </div>
                    <div class="replyTopItem">
                        <span>{{ $t('EmailOrPhone') + "：" }}</span>
                        <span>{{detail.contact}}</span>
                    </div>
                    <div class="replyTopItem">
                        <span>{{ $t('Country') + "：" }}</span>
                        <span>{{handCountryCodeName(detail.country)}}</span>
                    </div>
                    <div class="replyTopItem">
                        <span style="vertical-align: top;">{{ $t('Picture') + "：" }}</span>
                        <el-image v-for="item in detail.imageUrls" :key="item" :src="item" @click="showBigImg(item)" fit="cover" style="height:60px;margin-right: 10px;">
                            <div slot="placeholder" class="image-slot" style="width: 100px;">
                                {{ $t("Loading") }}<span class="dot">...</span>
                            </div>
                        </el-image>
                    </div>
                </div>
                <div style="display: flex;margin-top: 10px;" class="replyTopItem">
                    <span style="flex:none">{{ $t('Description') + "：" }}</span>
                    <div><img :src="isShowLoadmoreDesc ? loadmore_desc : loadless_desc" :title="isShowLoadmoreDesc ? $t('More') : $t('PackUp')" @click.stop="showMoreOrLessDesc()" class="replyDescImg" alt=""></div>
                    <div :class="isShowLoadmoreDesc ? 'replyDescShowLessItem' : 'replyDescShowAllItem'">{{detail.description}}</div>
                </div>
            </div>
            <div v-show="replyModel === 1">
                <div class="replyContentBox" ref="replyContentBox">
                    <div style="clear: both;" v-for="(item,index) in detail.replyRecord" :key="item.replyId">
                        <div v-show="item.isShowTime" style="text-align: center"><div class="replyContentTimeBox">{{item.showData}}</div></div>
                        <p :class="item.replyType === 1 ? 'userNameLeftTex' : 'userNameRightTex'">{{item.username}}</p>
                        <div @click="showSingleMessageDetail(item)" :class="['replyContentItem', item.replyType === 1 ? 'replyUserBox' : 'replyServiceBox']">
                            <img :src="item.showMore ? loadmore : loadless" :title="item.showMore ? $t('More') : $t('PackUp')" @click.stop="showMoreOrLess(item,index)" class="replyContentImg" alt="">
                            <p :class="[item.showMore ? 'replyContentShowLessItem' : 'replyContentShowAllItem']">
                                {{ item.content }}
                            </p>
                            
                        </div>
                    </div>
                    
                </div>
                <div class="replyContentFoot">
                    <el-button type="primary" size="small" :loading="detail.replyBtnStatu === 1" @click="replyUserMessages">{{$t('Reply')}}</el-button>
                    <el-button type="primary" size="small" class="ml4" :loading="detail.deniedBtnStatu === 1" @click="deniedUserMessages">{{$t('Denied')}}</el-button>
                    <el-button type="primary" size="small" class="ml4" :loading="detail.finishedBtnStatu === 1" @click="finishedUserMessages">{{$t('Finished')}}</el-button>
                    <el-button type="primary" size="small" class="ml4" :loading="detail.processingBtnStatu === 1" @click="processingUserMessages">{{$t('Processing')}}</el-button>
                    <el-button type="primary" size="small" class="ml4"  @click="detailUserMessagesBack">{{$t('Return')}}</el-button>
                </div>
            </div>
            <!-- 单个消息详情 -->
            <div style="margin-top: 20px;" v-show="replyModel === 2">
                <div class="messageDetailTex"><el-divider direction="vertical"></el-divider> <span>{{$t('ReplyContents')}}</span></div>
                <div class="replyContentSingleMessageBox">
                   <div class="replyContentSingleMessageTitle">{{new Date(singleMessageDetail.createTime).toISOString().split('T')[0]}}</div>
                   <div class="replyContentSingleMessageTex">{{singleMessageDetail.content}}</div>
                   <div class="replyContentSingleMessageImg">
                    <el-image v-for="item in singleMessageDetail.imageUrls" :key="item" :src="item" @click="showBigImg(item)" style="width: 100px; height:100px;margin-right: 10px;">
                        <div slot="placeholder" class="image-slot" style="width: 100px; height:100px;">
                            {{ $t("Loading") }}<span class="dot">...</span>
                        </div>
                    </el-image>
                   </div>
                    
                </div>
                <div v-show="singleMessageDetail.replyType === 2" class="replyContentSingleMessageAdminBox">
                    <span class="adminProcessTex">{{ $t('Process') + ":" }}</span> 
                    <div class="adminPoint"></div>
                    <span class="adminRole">{{ $t('Administrator') + ":"}}</span>
                    <span class="adminName">{{ singleMessageDetail.username }}</span>
                </div>

                <div class="replyContentFoot">
                    <el-button type="primary" size="small" class="ml4"  @click="singleMessageBack">{{$t('Back')}}</el-button>
                </div>
            </div>
            <!-- 回复 -->
            <div style="margin-top: 20px;" v-show="replyModel === 3">
                <div class="messageDetailTex"><el-divider direction="vertical"></el-divider> <span>{{$t('ReplyContents')}}</span></div>
                <div class="replyContentInputBox">
                    <el-input
                    type="textarea"
                    :rows="6"
                    resize='none'  
                    :placeholder="$t('EnterReplyContents')"
                    v-model="reply.content"
                    maxlength="2000"
                    show-word-limit
                    >
                    </el-input>
                    <div style="margin-left: 10px;margin-top: 10px;">
                        <div style="float: left;margin-bottom: 10px" v-for="item in reply.imgList" :key="item.uid">
                            <el-image  :src="item.url" style="width: 100px; height:100px;margin-right: 10px;">
                                <div slot="placeholder" class="image-slot" style="width: 100px; height:100px;">
                                    {{ $t("Loading") }}<span class="dot">...</span>
                                </div>
                            </el-image>
                            <div style="position: relative;">
                                <img :src="reply.delImg" style="position: absolute;left: 90px;top: -110px;" @click="delReplyImg(item)">
                            </div>
                        </div>
                        <el-upload
                            v-show="reply.isShowUpload"
                            style="float: left;margin-bottom: 10px"
                            ref="replyUploadImg"
                            :auto-upload="false"
                            :action="reply.actionUrl"
                            accept="image/jpeg,image/png"
                            :limit="4"
                            list-type="picture-card"
                            :on-change="handleFileChange"
                            :on-exceed="handFileExceed"
                            :file-list="reply.imgList"
                            :show-file-list="false"
                            >
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </div>
                    
                </div>

                <div class="replyContentFoot">
                    <el-button type="primary" size="small" :loading="reply.submitBtnStatu === 1" @click="replySubmitMessages">{{$t('Submit')}}</el-button>
                    <el-button type="primary" size="small" class="ml4"  @click="replyMessagesCancel">{{$t('Cancel')}}</el-button>
                </div>
            </div>
            
            
        </div>
    </div>
   
  
</template>

<script>
import {nanoid} from 'nanoid'
import { mapState } from 'vuex';
import loadmore from '@/assets/images/loadmore.png'
import loadmore_desc from '@/assets/images/loadmore_desc.png'
import loadless from '@/assets/images/loadless.png'
import loadless_desc from '@/assets/images/loadless_desc.png'
import delImg from "@/assets/images/deleteImg.png"
import userMessagesApi from '@/api/usermessages/index.js'
export default {
    name:"UserMessages",
    data(){
        return{
            model:1, //1:消息列表,2:详情
            replyModel:1, //1:消息详情,2:回复消息
            isNoMessages:false,
            showClose:true,
            isShowBigImgFrom:false,
            bigImgUrl:'',
            serach:{
                title:"",
                country:"",
                countryOptions:[],
                problemType:"",
                problemTypeOptions:[
                    {
                        id:'question',
                        name:this.$t('Question')
                    },
                    {
                        id:'bug',
                        name:this.$t('BUG')
                    },
                    {
                        id:'suggestion',
                        name:this.$t('Suggestion')
                    },
                    {
                        id:'app',
                        name:this.$t('APPOrPhone')
                    },
                    {
                        id:'others',
                        name:this.$t('Others')
                    },
                ],
                status:"",
                statusOptions:[
                    {
                        id:1,
                        name:this.$t('MessagesPending')
                    },
                    {
                        id:2,
                        name:this.$t('BeingProcessed')
                    },
                    {
                        id:3,
                        name:this.$t('MessagesEnd')
                    },
                    {
                        id:4,
                        name:this.$t('Denied')
                    },
                ],
                startTime:"",
                endTime:"",
                serachBtnState:0,
            },
            messagesListData:[],
            totalLogs:0,
            currentPage: 1,
            loadmore,
            isShowLoadmoreDesc:true,
            loadmore_desc,
            loadless,
            loadless_desc,
            detail:{
                userFeedbackId:'',
                title:'',
                userName:'',
                contact:'',
                description:'',
                imageUrls:[],
                replyRecord:[],
                messageStatu:1,
                replyBtnStatu:0,
                deniedBtnStatu:0,
                finishedBtnStatu:0,
                processingBtnStatu:0,
            },
            singleMessageDetail:{
                replyType:1,
                createTime:0,
                content:'',
                imageUrls:[],
                username:'',

            },
            reply:{
                isShowUpload:true,
                content:'',
                delImg,
                actionUrl:'',
                imgList:[],
                submitBtnStatu:0,
            }
            
        }
    },
    mounted(){
        let siteAssessBread = [
            {
                id:nanoid(),
                path:'/main/companydashboard',
                name:this.selectCompany === "createCompany"? "":this.selectCompany.companyName,
            },
            {
                id:nanoid(),
                path:'/main/sitedashboard',
                name:this.selectSite.siteName
            },
            {
                id:nanoid(),
                path:'/main/usermessages',
                name:this.$t('UserMessages')
            },
           
        ];
        this.$generateBreadcrumb(siteAssessBread);
        const hostUrl = sessionStorage.getItem('URL');
        this.reply.actionUrl = hostUrl + `/entranceserver/web-api/${this.selectCompany.companyRegion}/notice/device/picUpload`;
        //获取用户消息列表
        let serachMessagesObj = {
                "pageNum":1
            };
        this.serachUserMessages(serachMessagesObj);
        // this.handDateShow();
        this.serach.countryOptions = countryList;
    },
    methods:{
        //Message状态
        getMessagesStatusStr(obj){
            let getStr = "";
            switch(obj){
                case 1:
                    getStr = this.$t('MessagesPending');
                    break;
                case 2:
                    getStr = this.$t('BeingProcessed');
                    break
                case 3:
                    getStr = this.$t('MessagesEnd');
                    break
                case 4:
                    getStr = this.$t('Denied');
                    break
                default:
                    getStr = "";
                }
                return getStr;
        },
        //问题类型
        getProblemTypeStr(str){
            let getStr = "";
            switch(str){
                case 'question':
                    getStr = this.$t('Question');
                    break;
                case 'bug':
                    getStr = this.$t('BUG');
                    break
                case 'suggestion':
                    getStr = this.$t('Suggestion');
                    break
                case 'app':
                    getStr = this.$t('APPOrPhone');
                    break
                case 'others':
                    getStr = this.$t('Others');
                    break
                default:
                    getStr = "";
                }
                return getStr;
        },
        //处理国家代码与名称对应关系
        handCountryCodeName(code){
            let countryName = '';
            countryList.map(item => {
                if(code === item.id){
                    countryName = item.name;
                }
            })
            return countryName
        },
        //处理时间显示问题
        handDateShow(){
            let previousDate = null;
            this.detail.replyRecord.forEach((item, index) => {
                // 将时间戳转换为日期字符串
                const date = new Date(item.createTime).toISOString().split('T')[0];

                // 如果是第一条数据或者日期与上一条不同，显示时间
                if (index === 0 || date !== previousDate) {
                    // console.log(`${date} ${item.content}`); // 显示日期和内容
                    previousDate = date; // 更新 previousDate
                    item.isShowTime = true;
                    item.showData = date;
                } else {
                    // console.log(item.content); // 只显示内容，不显示日期
                    item.isShowTime = false;
                    item.showData = null;
                }
            });
        },
        //搜索用户消息
        serachUserMessages(obj){

            // if((this.serach.title).trim() != ""){
            //     let checkResultSurname = this.$regularCheckLimit(this.serach.title,1,30,'UserNameLimit');
            //     if(!checkResultSurname){
            //         return false
            //     }
            // }
            if(this.serach.startTime == null){
                this.serach.startTime = "";
            }
            if(this.serach.endTime == null){
                this.serach.endTime = "";
            }

            if(this.serach.startTime != "" && this.serach.endTime === ""){
                this.$message.info(this.$t('EndTimeEmptye'));
                return false
            }
            if(this.serach.startTime === "" && this.serach.endTime != ""){
                this.$message.info(this.$t('StartTimeEmptye'));
                return false
            }
            if(this.serach.startTime > this.serach.endTime){
                this.$message.info(this.$t('StartTimeLaterEndTime'));
                return false
            }

            let messagesObj = {
                "rgn":this.selectCompany.companyRegion,
                "title":this.serach.title,
                "problemType":this.serach.problemType,
                "country":this.serach.country,
                "status":this.serach.status,
                "startTime":this.serach.startTime,
                "endTime":this.serach.endTime,
                "siteId":this.selectSite.id,
                "pageSize":10,
                "pageNum":obj.pageNum,
            }
            userMessagesApi.getUserMessagesList(messagesObj).then(res => {
                if(res.code === 0){
                    if(res.data.list === null || res.data.list.length === 0){
                        this.isNoMessages = true;
                    }else{
                        this.isNoMessages = false;
                        this.currentPage = res.data.pageNum;
                        this.totalLogs = res.data.total;
                        this.messagesListData = [];
                        for(let i=0;i<res.data.list.length;i++){
                            this.messagesListData.push(res.data.list[i]);
                        }
                    }
                    
                }else{
                    this.$handerrcode(res.code);
                }
            }).catch((err) => {
                console.log(err)
            })
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            //获取assess log列表
            let serachMessagesObj = {
                    "pageNum":val
                };
            this.serachUserMessages(serachMessagesObj);
        },
        //点击more
        moreInfo(item){
            this.model = 2;
            this.getUserMessageDetailByMessgeId(item);
        },
        //根据消息id获取消息详情
        getUserMessageDetailByMessgeId(item){
            let getUserFeedbackId = '';
            if(item){
                getUserFeedbackId = item.userFeedbackId;
            }else{
                getUserFeedbackId = this.detail.userFeedbackId;
            }
            let detailObj = {
                "rgn":this.selectCompany.companyRegion,
                "userFeedbackId":getUserFeedbackId,
                "siteId":this.selectSite.id,                
            };
            this.detail.country = "";
            userMessagesApi.getUserMessagesDetail(detailObj).then(res => {
                if(res.code === 0){
                    this.detail.userFeedbackId = res.data.userFeedbackId;
                    this.detail.title = res.data.title;
                    this.detail.userName = res.data.username;
                    this.detail.contact = res.data.contact;
                    this.detail.country = res.data.country;
                    this.detail.messageStatu = res.data.status;
                    this.detail.description = res.data.content;
                    this.detail.imageUrls = [];
                    this.detail.imageUrls = res.data.imageUrls;
                    this.detail.replyRecord = [];
                    //处理时间
                    let previousDate = null;
                    res.data.replyRecord.forEach((item,index) => {
                        item.showMore = true;
                         // 将时间戳转换为日期字符串
                        const date = new Date(item.createTime).toISOString().split('T')[0];

                        // 如果是第一条数据或者日期与上一条不同，显示时间
                        if (index === 0 || date !== previousDate) {
                            previousDate = date; // 更新 previousDate
                            item.isShowTime = true;
                            item.showData = date;
                        } else {
                            item.isShowTime = false;
                            item.showData = null;
                        }
                        
                        this.detail.replyRecord.push(item);
                    });

                    //滚动到回复的最底部
                    this.$nextTick(()=>{
                        this.$refs.replyContentBox.scrollTop = this.$refs.replyContentBox.scrollHeight + 50;
                    })   

                }else{
                    this.$handerrcode(res.code);
                }
            }).catch((err) => {
                console.log(err);
            })
        },
        showBigImg(item){
            this.isShowBigImgFrom = true;
            this.bigImgUrl = item;
        },
        //描述点击加载更多/关闭加载更多
        showMoreOrLessDesc(){
            this.isShowLoadmoreDesc = !this.isShowLoadmoreDesc;
        },
        //展示更多
        showMoreOrLess(item,index){
            this.detail.replyRecord[index].showMore = !this.detail.replyRecord[index].showMore;
        },
        //单个消息点击查看详情
        showSingleMessageDetail(item){
            this.replyModel = 2;
            this.singleMessageDetail.replyType = item.replyType;
            this.singleMessageDetail.createTime = item.createTime;
            this.singleMessageDetail.content = item.content;
            this.singleMessageDetail.imageUrls = [];
            this.singleMessageDetail.imageUrls = item.imageUrls;
            this.singleMessageDetail.username = item.username;
        },
        //查看单个消息详情点击返回
        singleMessageBack(){
            this.replyModel = 1;
        },
        //点击回复按钮执行
        replyUserMessages(){
            this.replyModel = 3;
            this.reply.content = '';
            this.reply.imgList = [];
            this.reply.isShowUpload = true;
        },
        //点击拒绝执行
        deniedUserMessages(){
             this.updateUserMessageStatus(4);
        },
        //点击完成执行
        finishedUserMessages(){
            this.updateUserMessageStatus(3);
        },
        //点击处理执行
        processingUserMessages(){
            this.updateUserMessageStatus(2);
        },
        //更新消息状态函数
        updateUserMessageStatus(status){
            let rgnObj = {
                "rgn":this.selectCompany.companyRegion,
            };
            let putStatusObj = {
                "userFeedbackId":this.detail.userFeedbackId,
                "siteId":this.selectSite.id,
                status
            };
            if(status === 4){
                this.reply.deniedBtnStatu = 1;
            }else if(status === 2){
                this.reply.processingBtnStatu = 1;
            }else if(status === 3){
                this.reply.finishedBtnStatu = 1;
            }
            userMessagesApi.updateUserMessages(rgnObj,putStatusObj).then(res => {
                if(res.code === 0){
                    this.$message.success(this.$t('UserMessageStatusUpdate'));
                    if(status === 4){
                        this.reply.deniedBtnStatu = 0;
                    }else if(status === 2){
                        this.reply.processingBtnStatu = 0;
                    }else if(status === 3){
                        this.reply.finishedBtnStatu = 0;
                    }
                    this.model = 1;
                    this.replyModel = 1;
                    //获取用户消息列表
                    let serachMessagesObj = {
                            "pageNum":1
                        };
                    this.serachUserMessages(serachMessagesObj);
                }else{
                    if(status === 4){
                        this.reply.deniedBtnStatu = 0;
                    }else if(status === 2){
                        this.reply.processingBtnStatu = 0;
                    }else if(status === 3){
                        this.reply.finishedBtnStatu = 0;
                    }
                    this.$handerrcode(res.code);
                }
            }).catch((err) => {
                console.log(err);
                if(status === 4){
                    this.reply.deniedBtnStatu = 0;
                }else if(status === 2){
                    this.reply.processingBtnStatu = 0;
                }else if(status === 3){
                    this.reply.finishedBtnStatu = 0;
                }
            })
        },
        //点击返回执行
        detailUserMessagesBack(){
            this.model = 1;
        },
        handleFileChange(file,fileList){
            const isJPG = file.raw.type === 'image/jpeg';
            const isPNG = file.raw.type === 'image/png';
            if (!isJPG && !isPNG) {
                this.$message.info(this.$t("UploadImagejpgOrPng"));
                return false;
            }
            const fileSize = file.size / 1024 / 1024 <= 2;
            if (!fileSize) {
                this.$message.info(this.$t('UploadedImageLimit'));
                return false;
            }
            this.reply.imgList = fileList;
            if(this.reply.imgList.length < 4){
                this.reply.isShowUpload = true;
            }else{
                this.reply.isShowUpload = false;
            }
        },
        //超出个数限制
        handFileExceed(files, fileList){
            this.reply.isShowUpload = false;
            // this.$message.info(this.$t('FileExceed').replace('2','4'));
        },
        //删除回复图片
        delReplyImg(val){
            this.reply.imgList = this.reply.imgList.filter((item)=>{
                return val.uid != item.uid
            })
            if(this.reply.imgList.length < 4){
                this.reply.isShowUpload = true;
            }else{
                this.reply.isShowUpload = false;
            }
        },
        //提交回复
        replySubmitMessages(){
            if(this.reply.content.trim() === ""){
                this.$message.info(this.$t('ReplyEmpty'));
                return false;
            }
            let rgnObj = {
                "rgn":this.selectCompany.companyRegion,
            };
            // 创建 formData 对象
            const formData = new FormData();
            formData.append('userFeedbackId', this.detail.userFeedbackId);
            formData.append('title', this.detail.title);
            formData.append('content', this.reply.content);
            formData.append('siteId', this.selectSite.id);
            if(this.reply.imgList.length > 0){
                this.reply.imgList.forEach((item) => {
                    formData.append('files', item.raw);
                });
            }
            // formData.append('files', putImgList);
            // console.log('formData',formData);
            // return false
            this.reply.submitBtnStatu = 1;
            userMessagesApi.replyUserMessages(rgnObj,formData).then(res => {
                if(res.code === 0){
                    this.$message.success(this.$t('UserMessageReply'));
                    this.reply.submitBtnStatu = 0;
                    // this.model = 1;
                    this.replyModel = 1;
                    // 清空文件列表
                    this.reply.imgList = [];
                    this.reply.isShowUpload = true;
                    this.$refs.replyUploadImg.clearFiles();
                    this.getUserMessageDetailByMessgeId();
                    //获取用户消息列表
                    // let serachMessagesObj = {
                    //         "pageNum":1
                    //     };
                    // this.serachUserMessages(serachMessagesObj);
                }else{
                    this.reply.submitBtnStatu = 0;
                    this.$handerrcode(res.code);
                }
            }).catch((err) => {
                console.log(err);
                this.reply.submitBtnStatu = 0;
            })
        },
        //取消回复
        replyMessagesCancel(){
            this.replyModel = 1;
        },
    },
    computed:{
        ...mapState(["selectCompany","companyList","selectSite","userInfo"])
    },
    watch:{
      
    }
}
</script>

<style scoped>
::v-deep .el-dialog {
    border-radius: 15px !important;
    width: 1080px;
}
@media screen and (max-width: 600px) {
    ::v-deep .el-dialog {
        border-radius: 15px !important;
        min-width: 300px;
        overflow: auto;
    }
}
::v-deep .el-dialog__header {
    background-color: #6498B5 !important;
    border-radius: 15px 15px 0 0 !important;
}
::v-deep .el-dialog__title {
    color: #fff !important;
}
::v-deep .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 24px;
    line-height: 0.6;
}
::v-deep .el-dialog__headerbtn:focus .el-dialog__close,
::v-deep .el-dialog__headerbtn:hover .el-dialog__close {
  color: #fff !important;
}
/* ::v-deep .el-pagination__editor.el-input .el-input__inner{
    background-color: #99B9CB;
    color: #fff;
} */
.userMessagesBox{
    padding: 10px 30px;
}
@media screen and (max-width: 600px) {
    .userMessagesBox{
        padding: 20px 0;
    }
}
.serachBox{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 1vw;
}
@media screen and (max-width: 600px) {
    .serachBox{
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 30px 10px;
    }
}
.serachInput{
    width: 12vw;
    min-width: 170px;
    margin-right: 24px;
    border: 1px solid #979797;
    background: #fff;
    border-radius: 4px;
}
@media screen and (max-width: 600px) {
    .serachInput{
        width: 170px;
        border: 1px solid #979797;
        background: #fff;
        border-radius: 4px;
    }
}
::v-deep .serachInput .el-input__inner {
    height: 39px!important;
    line-height: 39px!important;
    border: none;
}
.serachSel{
    width: 12vw;
    min-width: 170px;
    margin-right: 24px;
    border: 1px solid #979797;
    background: #fff;
    border-radius: 4px;
}
@media screen and (max-width: 600px) {
    .serachSel{
        width: 170px;
        margin-top: 10px;
        border: 1px solid #979797;
        background: #fff;
        border-radius: 4px;
    }
}

::v-deep .serachSel .el-input__inner{
    border: none;
}
::v-deep .el-select .el-input.is-focus .el-input__inner{
    border: none;
}
::v-deep .el-select .el-input__inner:focus {
    border: none;
}
.dataBox{
    display: flex;
    align-items: center;
}
/* .dataBox div{
    margin-right: 10px;
} */
.dateDivider{
    line-height: 24px;
    padding: 0 6px;
}

::v-deep .el-pagination .el-input__inner {
    background: #fff;
    border: 1px solid #dcdfe6;
}
::v-deep .el-date-editor .el-input__inner {
    height: 42px!important;
    line-height: 42px!important;
    border: 1px solid #979797;
    background: #fff;
}
.el-select .el-input.is-focus .el-input__inner {
    border: none;
}

.serachBtn{
    margin-left: 24px;
}
@media screen and (max-width: 600px) {
    .serachBtn{
        margin-left: 24px;
    }
}
.serachLeft{
    margin-top: 0.5vw;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
}
@media screen and (max-width: 800px) {
    .serachLeft{
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-top: 10px;
    }
    .serachLeft div{
        margin-top: 10px;
    }
}


.el-divider--horizontal{
    height: 2px;
}
.noMessage{
    color: #ACACAC;
    margin-top: 10vw;
}
/* ::v-deep .el-table .el-table__cell{
    padding: 8px 0;
} */
::v-deep .el-table{
    min-height: 510px !important;
}
.pageBox {
    /* position: fixed;
    bottom: 2vw; */
    margin-top: 20px;
    width: 96%;
    justify-content: center;
}

@media screen and (max-width: 600px) {
    .pageBox {
        /* position: fixed;
        bottom: 10px; */
        margin-top: 20px;
        justify-content: center;
    }
    .el-pagination {
        width: 100vw;
        overflow: auto;
    }
}

.messageDetail{
    padding: 15px 30px;
}
.messageDetailTex{
    text-align: left;
}
.messageDetailTex span{
    font-size: 14px;
    font-weight: bold;
    margin-left: 5px;
}
.el-divider--vertical {
    width: 4px;
    margin: 0 !important;
    background-color: #6498B5;
}
.replyTopBox{
    margin-top: 10px;
    padding: 10px;
    background: #EEEEEE;
    text-align: left;
}
.replyTopBox::after{
    content: "";
    display: block;
    clear: both;
}
.replyTopItem{
    margin-right: 20px;
    margin-top: 10px;
}
.replyTopItem span{
    margin-right: 10px;
}
.replyTopItem span:first-child{
    color: #6498B5;
}
.replyDescShowLessItem{
    /* margin-left: 110px;
    margin-top: -20px; */
    font-size: 16px;
    line-height: 1.5;
    display: -webkit-box;
    -webkit-line-clamp: 3; /* 限制在一个块元素显示的文本的行数 */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis; /* 溢出时显示省略号 */
    cursor: pointer; /* 鼠标悬 */
    word-wrap: break-word;
}
.replyDescShowAllItem{
    /* margin-left: 110px;
    margin-top: -20px; */
    font-size: 16px;
    line-height: 1.5;
    display: -webkit-box;
    -webkit-line-clamp: none; /* 移除行数限制 */
     overflow: visible; /* 显示全部 */
     -webkit-box-orient: vertical;
    cursor: pointer; /* 鼠标悬 */
    word-wrap: break-word;
}
.replyDescImg{
    width: 12px;
    margin-top: 5px;
    margin-right: 5px;
    cursor: pointer;
}
.replyContentBox{
    margin-top: 10px;
    padding: 30px 10px;
    background: #EEEEEE;
    text-align: left;
    height: 50vh;
    overflow: auto;
}
.replyContentBox::after{
    content: "";
    display: block;
    clear: both;
}
.replyContentTimeBox{
    display: inline-block;
    padding: 4px 10px;
    border-radius: 8px;
    background-color: #fff;
    font-size: 12px;
}
.userNameLeftTex{
    margin-top: 5px;
    float: left;
    font-weight: bold;
    padding-left: 5px;
    font-size: 12px;
}
.userNameRightTex{
    margin-top: 5px;
    float: right;
    font-weight: bold;
    padding-right: 5px;
    font-size: 12px;
}
.replyContentItem{
    margin-top: 5px;
    padding: 10px;
    width: 30%;
    border: 1px solid #FBD584; 
    float: left;
    clear: both;
    background: #fff;
    border-radius: 8px;
}
.replyContentImg{
    float: left;
    width: 12px;
    margin-top: 5px;
    margin-right: 5px;
    cursor: pointer;
}
.replyContentShowLessItem{
    font-size: 14px;
    line-height: 1.5;
    display: -webkit-box;
    -webkit-line-clamp: 3; /* 限制在一个块元素显示的文本的行数 */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis; /* 溢出时显示省略号 */
    cursor: pointer; /* 鼠标悬 */
    margin-left: 5px;
    word-wrap: break-word;
}
.replyContentShowAllItem{
    font-size: 14px;
    line-height: 1.5;
    display: -webkit-box;
    -webkit-line-clamp: none; /* 移除行数限制 */
     overflow: visible; /* 显示全部 */
     -webkit-box-orient: vertical;
    cursor: pointer; /* 鼠标悬 */
    margin-left: 5px;
    word-wrap: break-word;
}
.replyUserBox{
    border: 2px solid #FBD584; 
    float: left;
}
.replyServiceBox{
    border: 2px solid #99D7A4; 
    float: right;
}
.replyContentFoot{
    margin-top: 20px;
}
.ml4{
    margin-left: 4px;
}
::v-deep .el-textarea{
    position: static;
}
::v-deep .el-textarea__inner{
    border: none !important;
}
::v-deep .el-upload--picture-card{
    width: 100px;
    height: 100px;
    line-height: 100px;
}
.delImg{
    width: 16px;
    position: absolute;
    top: -7px;
    right: -7px;
    background: #fff;
    border-radius: 22px;
}
.replyContentInputBox{
    margin-top: 20px;
    position: relative;
    border: 1px solid #979797;
    border-radius: 4px;
}
.replyContentInputBox::after{
    content: "";
    display: block;
    clear: both;
}

.replyContentSingleMessageBox{
    margin-top: 10px;
    padding: 10px;
    border-radius: 8px;
    border: 1px solid #EEEEEE;
}
.replyContentSingleMessageTitle{
    text-align: left;
    font-size: 16px;
    font-weight: bold;
}
.replyContentSingleMessageTex{
    text-align: left;
    margin-top: 20px;
    font-size: 14px;
    line-height: 1.5;
    word-wrap: break-word;
}
.replyContentSingleMessageImg{
    text-align: left;
    margin-top: 20px;
}
.replyContentSingleMessageAdminBox{
    text-align: left;
    margin-top: 10px;
}
.replyContentSingleMessageAdminBox::after{
    content: "";
    display: block;
    clear: both;
}
.adminProcessTex{
    font-size: 16px;
    font-weight: bold;
}
.adminPoint{
    display: inline-block;
    width: 4px;
    height: 4px;
    border-radius: 2px;
    background: #6498B5;
    margin-left: 10px;
    vertical-align: middle;
}
.adminRole{
    margin-left: 5px;
}
.adminName{
    margin-left: 5px;
}
::v-deep .el-upload-list--picture-card .el-upload-list__item {
    width: 100px;
    height: 100px;
}
.el-button--small{
    padding: 10px 30px;
}
.badgeItem{
    margin-top: 5px;
}
::v-deep .el-badge__content.is-fixed.is-dot{
    right: 0;
    top: 2px;
}
</style>